import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AlertController,
  LoadingController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.page.html',
  styleUrls: ['./addresses.page.scss'],
})
export class AddressesPage implements OnInit {
  addressForm: FormGroup;
  myAddresses = [
    // {street:'7th street Main',city:'New York',zipcode:'12324',name:'Home',phone:'0673538733',apt:'Main Building',state:'Washigton',delivery_instructions:'not added'}
  ];
  switchToAdd = false;
  phone: any;
  isSubmitted = false;
  constructor(
    public navCtrl: NavController,

    public formBuilder: FormBuilder,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private globals: GlobalVariable
  ) {
    this.addressForm = formBuilder.group({
      // Validators.pattern('[^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$]'),
      street: [
        '',
        Validators.compose([Validators.minLength(3), Validators.required]),
      ],
      city: [
        '',
        Validators.compose([
          Validators.minLength(2),
          Validators.pattern('[a-zA-Z ]*'),
          Validators.required,
        ]),
      ],
      name: [
        '',
        Validators.compose([Validators.minLength(2), Validators.required]),
      ],
      apt: [''],
      state: ['', Validators.compose([Validators.pattern('[a-zA-Z ]*')])],
      // phone : ['', Validators.compose([Validators.minLength(10),Validators.pattern('[0-9]*'),Validators.required])],
      zipcode: [
        '',
        Validators.compose([
          Validators.minLength(5),
          Validators.pattern('[0-9]*'),
          Validators.required,
        ]),
      ],
      delivery_instructions: [
        '',
        Validators.compose([Validators.maxLength(200)]),
      ],
    });
  }

  ngOnInit() {}
  ionViewWillEnter() {
    console.log('ionViewDidLoad AddressesPage');
    let tempArray = [];
    let response = localStorage.getItem('addresses');
    tempArray = JSON.parse(response);
    console.log('from local storage', tempArray);
    if (tempArray != null) {
      this.myAddresses = tempArray;
    }
  }
  addNewAddress() {
    this.switchToAdd = true;
  }
  async submit() {
    this.isSubmitted = true;
    if (!this.addressForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    }
    // const loading= await this.loadingController.create({
    //   message:'Saving ..',
    //   duration:1000,
    // });
    // await loading.present();
    // this.globals.Loader();
    this.globals.presentToast(
      'Saving new Address...',
      1000,
      'middle',
      'success'
    );
    // add loading
    console.log(this.addressForm.value);
    if (this.myAddresses.length < 5) {
      this.myAddresses.push(this.addressForm.value);
      console.log(this.myAddresses);
      localStorage.setItem('addresses', JSON.stringify(this.myAddresses));
      this.switchToAdd = false;
      // reset the form/ clear form

      // this.globals.loading.dismiss();
      this.addressForm.reset();
    } else {
      this.globals.presentToast(
        'You cannot add more addresses.try deleting old ones'
      );
    }
    //  this.addressForm.v
  }
  get errorControl() {
    return this.addressForm.controls;
  }
  async deleteAddress(address, i) {
    // add alert before delete
    const alert = await await this.alertController.create({
      header: 'Delete Address',
      message: 'You are about to delete address',
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'cancel_btn',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Delete',
          handler: (data) => {
            if (i > -1) {
              this.myAddresses.splice(i, 1);
              console.log(this.myAddresses.length);
              localStorage.setItem(
                'addresses',
                JSON.stringify(this.myAddresses)
              );
            }
          },
        },
      ],
    });
    await alert.present();

    // this.myAddresses.splice(i,1)
    console.log(address, i);
  }
  cancel() {
    this.switchToAdd = false;
    this.addressForm.reset();
  }
}
